import React, {useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Fade from "react-reveal/Fade"
import QtaSelector from "../parts/QtaSelector";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import {Link} from "react-router-dom";

function Carrello(props){
    return <Container>
        <BoxList lista={props.liste[0]}
                 addToList={props.addToList}
                 removeToList={props.removeToList}
                 deleteFromList={props.deleteFromList}
                 config={props.config}
                 domicilio={props.domicilio}
                 setDomicilio={props.setDomicilio}
                 openOrderModal={props.openOrderModal}/>
    </Container>;
}

function BoxList(props){
    const orderMinAlertVisible = props.lista.totPrezzo < props.config.minimoOrdine && props.lista.piatti.length > 0;
    return <div id={"carrello-piatti"} className={"under-header"}>
        {
            props.lista.piatti.length === 0 && <div className={"non-available"}>
                <i className="fas fa-fish"></i> Comincia ora ad aggiungere prodotti nel carrello
                <Link to={'/'} className={"d-block"}>
                    <div className="btn btn-aggiungi button-aggiungi">AGGIUNGI PIATTI</div>
                </Link>
            </div>
        }
        <Fade top collapse when={orderMinAlertVisible}>
            <Alert variant={"danger"}>
                <i className="fas fa-exclamation-triangle"></i>
                {` Aggiungi ancora piatti per € ${(parseFloat(props.config.minimoOrdine)-props.lista.totPrezzo).toFixed(2)} per poter ordinare.`}
            </Alert>
        </Fade>
        {
            props.lista.piatti.map((piatto) =>
                <CarrelloPiatti piatto={piatto}
                                key={piatto.id}
                                lista={0}
                                addToList={props.addToList}
                                removeToList={props.removeToList}
                                deleteFromList={props.deleteFromList} />
            )
        }
        <RiepilogoOrdine lista={props.lista}
                         domicilio={props.domicilio}
                         setDomicilio={props.setDomicilio}
                         config={props.config}/>
        <ConfermaButton lista={props.lista}
                        config={props.config}
                        openOrderModal={props.openOrderModal}/>
    </div>;
}

function ModeSelector(props){
    // Non mostrare nulla se l'unica opzione disponibile è l'asporto
    if(props.config['asporto'] ^ props.config['domicilio']){
        return "";
    }
    return <div className={"text-center"}>
        <Form.Check custom inline label="Asporto" type={"radio"} name={"domicilio"} id={"domicilioOff"} checked={!props.domicilio}
                    onChange={(ev) => props.setDomicilio(!ev.target.checked)}/>
        <Form.Check custom inline label="Domicilio" type={"radio"} name={"domicilio"} id={"domicilioOn"} checked={props.domicilio}
                    onChange={(ev) => props.setDomicilio(ev.target.checked)}/>
    </div>
}

function RiepilogoOrdine(props){
    if(!props.lista.nElementi){
        return "";
    }
    let speseDomicilio = 0;
    if(props.domicilio){
        speseDomicilio = parseFloat(props.config.prezzoDomicilio);
    }
    let totOrdine = parseFloat(props.lista.totPrezzo+speseDomicilio).toFixed(2);
    return <>
        <ModeSelector config={props.config}
                      domicilio={props.domicilio}
                      setDomicilio={props.setDomicilio} />
        <Fade bottom opposite collapse when={props.domicilio} >
            <div id={"dettagli-riepilogo"}>
                <div className="dettaglio-riepilogo">
                    <Row>
                        <Col xs={8} className={"detail"}>Spese domicilio</Col>
                        <Col xs={4} className="price">€ {parseFloat(props.config.prezzoDomicilio).toFixed(2)}</Col>
                    </Row>
                </div>
            </div>
        </Fade>
        <div id="riepilogo-ordine">
            <div className="dettaglio-riepilogo tot">
                <Row>
                    <Col xs={8} className={"detail"}>Totale da pagare</Col>
                    <Col xs={4} className="price">€ {totOrdine}</Col>
                </Row>
            </div>
            {
                props.config.avvisoOrdine &&
                <Alert id="ordine-warning" variant={"warning"}>
                    <b>Attenzione:</b> {props.config.avvisoOrdine}
                </Alert>
            }
        </div>
    </>
}

function ConfermaButton(props){
    // Visibile solo quando tutti i parametri per effettuare un ordine sono corretti
    const visible = props.lista.nElementi && props.lista.totPrezzo >= props.config.minimoOrdine;
    return <Fade bottom collapse when={visible}>
        <button className="btn btn-aggiungi btn-lg btn-block d-none d-md-block" onClick={props.openOrderModal}>
            <i className="fas fa-paper-plane"></i> Conferma l'ordine
        </button>
    </Fade>;
}

function CarrelloPiatti(props){
    const [show, setShow] = useState(true);
    let modificaQta = (val) =>{
        if(val < 0){
            if(props.piatto.qta > 1)
                props.removeToList(props.piatto, props.lista, 1);
        }else{
            props.addToList(props.piatto, props.lista, 1, true);
        }
    }
    function deletePiatto(){
        setShow(false);
        setTimeout(() => props.deleteFromList(props.piatto, props.lista), 800);
    }
    return <Fade bottom opposite collapse when={show}>
        <div className="piatto-carrello">
            <Row>
                <div className="col-10 col-md-9 order-1 order-md-2 titolo-piatto">{props.piatto.numero}. {props.piatto.nome}</div>
                <div className="col-md-2 col-6 order-3 order-md-3 comandi-qta">
                    <QtaSelector modificaQta={modificaQta}
                                 qta={props.piatto.qta}/>
                </div>
                <div className="col-2 col-md-1 order-2 order-md-1 cancel-piatto">
                    <button className="btn btn-link" onClick={() => deletePiatto()}>
                        <i className="fas fa-window-close"></i>
                    </button>
                </div>
                <div className="col-6 col-md-12 order-4 prezzo-piatto">
                    {`€ ${(parseFloat(props.piatto.prezzo)*parseFloat(props.piatto.qta)).toFixed(2)}`}
                </div>
            </Row>
        </div>
    </Fade>
}

export default Carrello;
